<template>
	<div class="choose-actions">
		<egranty-section-divider
			:text="numberOfModules > 1 ? 'Działania programowe modułu ' + moduleNumber : 'Działania programowe projektu'"
			icon="flag"
			:show-print-info="showPrintInfo"
		/>

		<div  class="action-cards-wrap" style="display: flex">
			<div
				v-for="(action,index) in current"
				:key="index"
				class="action-card"
			>

				<v-card class="choose-actions-card">
					<v-toolbar :color="getStatusColor(action)" dark style="margin: 0" class="">
						<h3>Działanie nr {{action.serialNumber}} {{getStatus(action)}}</h3>
						<v-spacer/>
						<project-button
							class="no-print"
							v-if="!readonly && index !== 0"
							icon="arrow_drop_up"
							@click='moveActionUp(index)'
						></project-button>
						<project-button
							class="no-print"
							v-if="!readonly && index !== current.length - 1"
							icon="arrow_drop_down"
							@click='moveActionDown(index)'
						></project-button>
						<project-button
							class="no-print"
							delete-button
							v-if="!readonly"
							text="Usuń działanie"
							icon="delete"
							@click='showRemoveActionDialog(index)'
						></project-button>
					</v-toolbar>

					<egranty-text-input-field
						:disabled="readonly"
						class="mt-3 choose-action-place"
						v-model="action.action"
						label='Nazwa'
						:outline="false"
						:textarea="true"
						rows="1"
						:auto-grow="true"
						for="choose-actions-action-name"
						id="choose-actions-action-name"
						@input="sync"
					></egranty-text-input-field>

					<egranty-text-input-field class="choose-action-place"
						:disabled="readonly"
						v-model="action.place"
						label="Miejsce"
						for="choose-actions-place"
						id="choose-actions-place"
						@input="sync"
					></egranty-text-input-field>

					<egranty-text-input-field class="choose-action-place"
						:disabled="readonly"
						v-model="action.description"
						label="Opis"
						for="choose-actions-description"
						id="choose-actions-description"
						@input="sync"
						textarea=true
                        autoGrow=true
                        :validationRules="[
                        value => value.length > maxDescriptionLengthCharacters ? 'Opis powinien zawierać mniej niż ' +maxDescriptionLengthCharacters+ ' znaków' : null
                          ]"
					></egranty-text-input-field>

					<project-choose-beneficiaries
						v-if="contestId !== null"
						:readonly="readonly"
						v-model="action.beneficiariesData"
						:contestId="contestId"
						id="choose-actions-group"
					></project-choose-beneficiaries>


					<div class="choose-actions-realization-date"
						v-for="(dates, datesIndex) in action.realizationDates"
						:key='datesIndex'>
						<v-layout row>
							<egranty-date-picker
								:disabled="readonly"
								v-model="dates.start"
								label="Początek"
								for="choose-actions-start"
								id="choose-actions-start"
								:min="minStart"
								:max="maxEnd"
							></egranty-date-picker>

							<egranty-date-picker
								:disabled="readonly"
								v-model="dates.end"
								label="Koniec"
								for="choose-actions-end"
								id="choose-actions-end"

								:min="minStart"
								:max="maxEnd"
							></egranty-date-picker>

							<project-button
								v-if="!readonly"
								delete-button
								text="Usuń"
								icon="delete"
								@click="action.realizationDates.splice(datesIndex, 1)"
							></project-button>

						</v-layout>
					</div>
					<project-button class="choose-actions-add-date no-print"
						v-if="!readonly"
						text="Dodaj termin realizacji"
						icon="date_range"
						@click="addRealizationDate(index)"
					></project-button>


					<egranty-validation-error
						v-for="error in action.errors"
						:key="error"
						:error=error
					></egranty-validation-error>
				</v-card>


			</div>

			<div v-if="!current.length">
				<egranty-validation-error
					:error="error"
				></egranty-validation-error>
			</div>
		</div>
		<project-button
			class="no-print"
			v-if="!readonly"
			:text="current.length === 0 ? 'Dodaj działanie' : 'Dodaj kolejne działanie'"
			icon="add"
			@click="addAction"
		></project-button>
		<v-dialog v-model="removeActionDialog" width="500">
		<v-card>
			<v-card-title class="headline" primary-title>
				Usunięcie działania programowego
			</v-card-title>

			<v-card-text>
				Czy na pewno chcesz usunąć działanie programowe i powiązane z nim koszty programowe?
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="removeAction(removeActionDialogItemIndex)">
					Tak
				</v-btn>
				<v-btn color="blue" @click="removeActionDialog = false; removeActionDialogItemIndex = null;">
					Nie
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	<v-dialog v-if="!readonly" v-model="warningInformationDialog" width="500">
		<v-card>
			<v-card-title class="headline" primary-title>
				Informacja
			</v-card-title>

			<v-card-text>
				Zmiany dotyczące działań programowych mają wpływ na inne części formularza. Zapisz je przed przejściem do innej zakładki.
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn @click="warningInformationDialog=false">
					Ok
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	</div>
</template>

<script>
	import EgrantyTextInputField from "../../../../genericComponents/EgrantyTextInputField";
	import ProjectChooseBeneficiaries from "./ProjectChooseBeneficiaries";
	import ProjectButton from "./ProjectButton";
	import EgrantyDatePicker from "../../../../genericComponents/EgrantyDatePicker";
	import EgrantyValidationError from "../../../../genericComponents/EgrantyValidationError";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";

	export default {
		name: "ProjectChooseActions",
		components: {
			EgrantySectionDivider,
			EgrantyValidationError,
			EgrantyDatePicker, ProjectButton, ProjectChooseBeneficiaries, EgrantyTextInputField
		},
		data() {
			return {
				error: "",
				current: [],
        currentCosts: [],
        costsIds: [],
				datesOpen: [],
				removeActionDialog: false,
				removeActionDialogItemIndex: null,
				warningInformationDialog: true,
				maxDescriptionLengthCharacters : 1000
			};
		},

		watch: {
			actions: {
				immediate: true,
				handler(val, oldVal) {
					if (val === undefined) {
						val = [];
					}
					if (oldVal === undefined) {
						val.sort((a, b) => a.serialNumber - b.serialNumber);
					}
					this.current = val;
				},
			},

      actionsCosts: {
        immediate: true,
        handler(val) {
          if (val === undefined) {
            val = [];
          }
          this.currentCosts = val;
        }
      },

      actionsCostsActionIds: {
        immediate: true,
        handler(val) {
          if (val === undefined) {
            val = [];
          }
          this.costsIds = val;
        }
      },
		},

		methods: {

			getStatusColor (action) {
				if (this.getStatus(action) === '(Usunięte)') {
					return "red lighten-2";
				}
				if (this.getStatus(action) === '(Nowe)') {
					return "green lighten-2";
				}
				if (this.getStatus(action) === '(Zmienione)') {
					return "blue lighten-2";
				}
				return "grey lighten";
			},

			getStatus (action) {
				if (this.oldVersion) {
					let found = this.oldVersion.find(x => x.serialNumber === action.serialNumber);
					if (!found) {
						return "(Nowe)";
					} else {
						action.id = 0;
						found.id = 0;
						if (JSON.stringify(action) !== JSON.stringify(found)) {
							return "(Zmienione)";
						}
					}
				}
				if (this.newVersion) {
					let found = this.newVersion.find(x => x.serialNumber === action.serialNumber);
					if (!found) {
						return "(Usunięte)";
					} else {
						action.id = 0;
						found.id = 0;
						if (JSON.stringify(action) !== JSON.stringify(found)) {
							return "(Zmienione)";
						}
					}
				}

				return "";
			},

			validate() {
				let valid = true;

				if (this.current.length === 0) {
					valid &= false;
					this.error = "Proszę dodać co najmniej jedno działanie";
				}
				for (let action of this.current) {
					valid &= this.validateAction(action);
				}
				if (valid) { //valid tutaj jest 1 lub 0, jak zwracamy przez return valid to uznaje to jako błąd
					return true;
				}
				return false;
			},

			validateAction(action) {
				this.$set(action, 'errors', []);
				if (action.action === '') {
					action.errors.push("Proszę uzupełnić nazwę działania");
				}
				if (action.place === '') {
					action.errors.push("Proszę uzupełnić miejsce działania");
				}
				if (!action.description) {
					action.errors.push("Proszę uzupełnić opis działania");
				}
				if (action.description.length > this.maxDescriptionLengthCharacters) {
					action.errors.push("Opis działania zawiera więcej niż: " + this.maxDescriptionLengthCharacters + " znaków");
				}
        if (!action.beneficiariesData.otherBeneficiary && !action.beneficiariesData.selected.length) {
          action.errors.push("Proszę uzupełnić grupę docelową");
        }
				if (!action.realizationDates.length) {
					action.errors.push("Proszę dodać co najmniej jeden termin realizacji działania");
				}
				for (var date of action.realizationDates) {
					if (!date.start || !date.end) {
						action.errors.push('Proszę uzupełnić brakujące terminy realizacji działań');
						break;
					}
					if (date.start > date.end) {
						action.errors.push('Daty końców terminów realizacji działań nie mogą być wcześniejsze niż ich początków');
						break;
					}

					if (date.start < this.minStart) {
						action.errors.push('Daty początków terminów realizacji działań nie mogą być wcześniejsze niż data rozpoczęcia modułu');
						break;
					}

					if (date.end > this.maxEnd) {
						action.errors.push('Daty końców terminów realizacji działań nie mogą być późniejsze niż data zakończenia modułu');
						break;
					}
				}
				return action.errors.length === 0;
			},

			sync() {
				for (var action of this.current) {
					this.$set(action, 'errors', []);
				}
        this.$emit("update:actions", this.current);
        this.$emit("update:actionsCosts", this.currentCosts);
        this.$emit("update:actionsCostsActionIds", this.costsIds);
			},

      moveActionUp(index) {
        let tmp = this.current[index];
        this.current[index] = this.current[index - 1];
        this.current[index - 1] = tmp;
        let serialTmp = this.current[index].serialNumber;
        this.current[index].serialNumber = this.current[index - 1].serialNumber;
        this.current[index - 1].serialNumber = serialTmp;
        this.reassignSerialNumbers();
        this.$emit("update-actions-and-costs", this.current, index - 1, index);
      },

      moveActionDown(index) {
        let tmp = this.current[index];
        this.current[index] = this.current[index + 1];
        this.current[index + 1] = tmp;
        let serialTmp = this.current[index].serialNumber;
        this.current[index].serialNumber = this.current[index + 1].serialNumber;
        this.current[index + 1].serialNumber = serialTmp;
        this.$emit("update-actions-and-costs", this.current, index, index + 1);
      },
			showRemoveActionDialog(index){
				this.removeActionDialog = true;
				this.removeActionDialogItemIndex= index;
			},

			removeAction(index) {
				this.current.splice(index, 1);
        this.costsIds.splice(index, 1);
        this.currentCosts.splice(index, 1);
				this.reassignSerialNumbers();
				this.sync();
				this.removeActionDialog = false;
				this.removeActionDialogItemIndex= null;
			},

			addRealizationDate(index) {
				this.current[index].realizationDates.push(
					{
						start: "",
						end: "",
					},
				);
			},

			addAction() {
				this.current.push(
					{
						place: "",
						description: "",
						action: "",
            beneficiariesData: {
              otherBeneficiary: null,
              selected: [],
            },
						realizationDates: [
							{
								start: "",
								end: "",
							}
						],
						serialNumber: null,
						id: this.getFreeId(),
						idFake: true,
					});
				this.reassignSerialNumbers();
				this.sync();
			},

			reassignSerialNumbers() {
        if (this.readonly) return;

				for (let action of this.current) {
					if (!this.isSerialNumberPermanentlyTaken(action.serialNumber)) {
						action.serialNumber = null;
					}
				}

				for (let action of this.current) {
					if (!this.isSerialNumberPermanentlyTaken(action.serialNumber)) {
						action.serialNumber = this.getSerialNumber();
					}
				}
				this.current = this.current.sort((a,b) => a.serialNumber - b.serialNumber);
			},

			isSerialNumberPermanentlyTaken(serialNumber) {
				for (let action of this.takenSerialNumbers.takenActionsSerialNumbers) {
					if (action.actionSerialNumber === serialNumber) {
						return true;
					}
				}
				return false;
			},

			getSerialNumber() {
				let freeNumber = 0;
				let failed;
				do {
					failed = false;
					freeNumber++;
					for (let action of this.current) {
						if (action.serialNumber === freeNumber) {
							failed = true;
						}
					}
					for (let action of this.takenSerialNumbers.takenActionsSerialNumbers) {
						if (action.actionSerialNumber === freeNumber) {
							failed = true;
						}
					}
				} while (failed);
				return freeNumber;
			},

			getFreeId() {
				let firstFree = 0;
				for (let action of this.current) {
					firstFree = Math.max(1 + action.id, firstFree);
				}
				return firstFree + this.moduleId * 100000;
			},
		},

		props: {
			takenSerialNumbers: {},
			contestId: null,
			readonly: {
				default: false
			},
			actions: {},
      actionsCosts: {},
      actionsCostsActionIds: {},
			oldVersion: {},
			newVersion: {},
			moduleId: {},
			minStart: String,
			maxEnd: String,
			moduleNumber: {
				default: "",
			},
			numberOfModules: {
				default: 0,
			},
			showPrintInfo: {
				type: Boolean, default: false
			}
		},
	};
</script>

<style scoped>

	.choose-actions .theme--dark.v-btn:not(.v-btn--icon):not(.v-btn--flat) {
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.choose-actions .v-input__control {
		margin-left: 20px;
		margin-right: 20px;
	}

	.choose-action-place {
		padding-left: 10px;
		padding-right: 10px;
	}

	.choose-actions-realization-date {
		padding-left: 10px;
		padding-right: 10px;
	}

	.grey {
		background-color: #0052A5 !important;
	}
	.action-cards-wrap {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}
	.action-card {
		flex: 0 50%;
	}
	.choose-actions-card {
		height: 100%;
	}
/*
	strong {
		font-size: 20px !important;
	}

	.application.mediumFont strong {
		font-size: 22px !important;
}

	.application.largeFont strong {
		font-size: 24px !important;
} */
</style>
<style>
	.toolbar-action-card .v-toolbar__content {
		justify-content: space-between;
	}
</style>
